module.exports = __webpack_public_path__ + "static/media/event1-image.315e09e7.png";